import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { required } from 'react-admin';
import { Stack } from 'shared/mui/Stack/Stack';
import { NumberInput, TextInput } from 'shared/react-admin/Inputs';

export const ReferralsForm = () => {
  const translate = useTypedTranslate();

  return (
    <Stack direction="row" gap={3} py={3} width="100%">
      <NumberInput
        fullWidth
        helperText={false}
        label={translate('app.referrals.refId')}
        size="small"
        source="refId"
        validate={required()}
        variant="outlined"
      />
      <TextInput
        fullWidth
        helperText={false}
        label={translate('app.table.name')}
        size="small"
        source="name"
        validate={required()}
        variant="outlined"
      />
    </Stack>
  );
};
